import React from 'react';

import { Tooltip, withStyles, Theme } from '@material-ui/core';

import { useStyles } from './style';

interface CustomToolTipProps {
  title?: NonNullable<React.ReactNode>;
  showTitle?: boolean;
  showCircle?: boolean;
  backgroundColor?: string;
  minWidth?: number | string;
  maxWidth?: number | string;
  placement?:
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end';
  labelValue: any;
  ref: any;
}

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: 'unset',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: 'unset',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#313739',
  },
}))(Tooltip);

export const CustomTooltip: React.FC<CustomToolTipProps> = React.forwardRef(
  (props, ref) => {
    const classes = useStyles(props);
    const {
      labelValue,
      children,
      backgroundColor,
      title,
      showTitle = true,
      showCircle = true,
      placement = 'bottom',
      maxWidth = undefined,
    } = props;

    return (
      <HtmlTooltip
        ref={ref}
        placement={placement}
        style={{ width: maxWidth }}
        PopperProps={{
          popperOptions: {
            modifiers: {
              placement: 'bottom',
              offset: {
                enabled: true,
                offset: '0, -25% - 17.5',
              },
            },
          },
        }}
        title={
          /* eslint react/jsx-wrap-multilines:0 */
          <>
            <div className={classes.tooltip}>
              {showTitle && title && (
                <div className={classes.ttheader}>{title}</div>
              )}
              <div className={classes.ttbody}>
                {showCircle && (
                  <>
                    <div
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: '100%',
                        backgroundColor,
                      }}
                    >
                      &nbsp;
                    </div>
                    <span style={{ marginLeft: 4 }}>:</span>
                  </>
                )}
                <div style={{ marginLeft: 4, fontWeight: 'bold' }}>
                  {labelValue}
                </div>
              </div>
            </div>
          </>
        }
      >
        <div>{children}</div>
      </HtmlTooltip>
    );
  },
);
